const baseURL = "/v1/DashboardFormacao";

const service = {
    methods: {

        //Dashboard GRE
        $buscarDashboardGre(params) {
            return this.$api().get(`${baseURL}/Gre`, params);
        },
        $buscarDashboardStatusFormacao(params) {
            return this.$api().get(`${baseURL}/Status`, params);
        },
        $buscarDashboardParticipantes(params) {
            return this.$api().get(`${baseURL}/Participantes`, params);
        },
        $buscarDashboardListaFormacoes(params) {
            return this.$api().get(`${baseURL}/Formacoes`, params);
        },
        $obterGresFormacaoParaDashboard(params) {
            return this.$api().get(`${baseURL}/Gre-formacao`, params);
        },
        //Pdfs
        $buscarDashboardListaFormacoesPdf(params) {
            return this.$api().get(`${baseURL}/FormacoesPdf`, this.$getParamsObject(params));
        },
        $buscarDashboardStatusFormacaoPdf(params) {
            return this.$api().get(`${baseURL}/StatusPdf`, this.$getParamsObject(params));
        },
        $buscarDashboardParticipantesPdf(params) {
            return this.$api().get(`${baseURL}/ParticipantesPdf`, this.$getParamsObject(params));
        },
        $buscarDashboardGrePdf(params) {
            return this.$api().get(`${baseURL}/GrePdf`, this.$getParamsObject(params));
        },

        //Dashboard ESCOLAS
        $buscarDashboardEscolas(params) {
            return this.$api().get(`${baseURL}/Escolas`, params);
        },
        $buscarDashboardEscolaUnica(params) {
            return this.$api().get(`${baseURL}/EscolaUnica`, params);
        },
        $buscarDashboardEscolasComFormacao(params) {
            return this.$api().get(`${baseURL}/EscolasComFormacao`, params);
        },
        //Pdfs
        $buscarDashboardEscolasPdf(params) {
            return this.$api().get(`${baseURL}/EscolasPdf`, this.$getParamsObject(params));
        },
        $buscarDashboardEscolaUnicaPdf(params) {
            return this.$api().get(`${baseURL}/EscolaUnicaPdf`, this.$getParamsObject(params));
        },
        $buscarDashboardListaEscolasComFormacoesPdf(params) {
            return this.$api().get(`${baseURL}/EscolasComFormacaoPdf`, this.$getParamsObject(params));
        },
        
        //Dashboard SEE
        $buscarDashboardSee(params) {
            return this.$api().get(`${baseURL}/See`, params);
        },
        $obterSeesFormacaoParaDashboard(params) {
            return this.$api().get(`${baseURL}/See-formacao`, params);
        },
        //Pdfs
        $buscarDashboardSeePdf(params) {
            return this.$api().get(`${baseURL}/SeePdf`, this.$getParamsObject(params));
        },
    },
};

export default service;